
import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Grid,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  StepConnector,
} from "@mui/material";
import {
  Mail as MailIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  LocalPrintshop as PrintIcon,
  CancelPresentation as CancelPresentationIcon,
} from "@mui/icons-material";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { styled } from "@mui/material/styles";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReceiptStepper1 from "./ReceiptStepper1";
import ReceiptStepper2 from "./ReceiptStepper2";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import { fetchPNDLR, SendEmailReceipt, GetReportTrnBooking } from "./Api/Api";
import moment from "moment";
import { useLocation, useNavigate, Link } from "react-router-dom";
import ReceiptPrint from "./ReceiptPrint";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import SendIcon from '@mui/icons-material/Send';
import { ConfirmDialog } from '../../ReusablePopup/CustomModel';

const steps = ["Main", "Details"];
const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderColor: "#e0e0e0",
    borderTopWidth: 3,
    borderRadius: 1,
    margin: "7px 30px 20px 30px",
  },
}));

const CustomStepIcon = styled("div")(({ theme, ownerState }) => ({
  width: 40,
  height: 40,
  border: "3px solid",
  borderColor: ownerState.active ? "#7c3aed" : "#e0e0e0",
  borderRadius: "50%",
  backgroundColor: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: ownerState.active ? "#7c3aed" : "#999",
  fontSize: "1.2rem",
  fontWeight: "bold",
}));

const CustomStepLabel = styled(StepLabel)({
  flexDirection: "column",
  "& .MuiStepLabel-labelContainer": {
    marginTop: "5px",
  },
});

const StepperForm = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    RecDt: '',
    RecNo: '',
    ResidentId: "",
    PropId: "",
    PropName: "",
    RecFlag: '',
    AccLedId: 0,
    RctVchrRef: '',
    RcdAmt: 0,
    AgstBill: 0,
    OnacAmt: 0,
    OnacBal: 0,
    Pyttype: '',
    PytMode: '',
    TrjId: '',
    ChequeNo: '',
    ChqInfvr: '',
    ChqDt: '',
    ClgDt: null,
    BankName: '',
    CardNo: '',
    AccountNo: '',
    IFSC: '',
    Status: '',
    Remark: '',
    TrnRctVchrList: []
  });
  const navigate = useNavigate();
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [AllTextDisabled, setAllTextDisabled] = useState(false);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(false);
  const [RecId, setRecId] = useState(-1);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const location = useLocation();
  const contentRef = useRef(null);
  const [residents, setResidents] = useState([]);
  const handlePrint = useReactToPrint({ contentRef });
  const [loading, setLoading] = useState(false);
  const [propId, setPropId] = useState(null);
  const [disableResidentFields, setDisableResidentFields] = useState(true);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode");
    const RecId = queryParams.get("RecId");
    if (mode === "view" && RecId) {
      fetchReceiptData(RecId, "R");
    } else {
      console.log("Add mode or no RecId found");
      handleAdd();
    }
  }, [location.search]);

  const fetchReceiptData = async (RecId, Flag) => {
    try {
      const response = await fetchPNDLR({
        RecId: RecId === -1 ? 1 : RecId,
        Flag: Flag,
        "CreatedBy": UserId,
      });
      if (response.data.Status === 0) {
        const receiptData = response.data.Data.TrnRctVchrList[0];
        const firstTransaction = receiptData.TrnRctVchrList?.[0];

        setTableData([]);
        setFormData({
          ...receiptData,
          PropId: receiptData?.PropId || '',
          PropName: receiptData?.PropName || 'No Property Available',
        });
        setRecId(receiptData.RecId);
        setAllTextDisabled(true);
        setAllButtonDisabled(false);
      } else {
        // toast.error(response.data.Message);
      }
      return response;
    } catch (error) {
      toast.error("Failed to load receipt data");
    }
  };

  const handleAdd = () => {
    setAllTextDisabled(false);
    setDisableResidentFields(false)
    setAllButtonDisabled(true);
    setTableData([])
    setFormData({
      RecDt: "",
      ResidentId: "",
      RecFlag: "",
      PropId: "",
      PropName: "",
      AccLedId: 0,
      RctVchrRef: "",
      RcdAmt: 0,
      AgstBill: 0,
      OnacAmt: 0,
      OnacBal: 0,
      Pyttype: "",
      PytMode: "",
      TrjId: "",
      ChequeNo: "",
      ChqInfvr: "",
      ChqDt: "",
      ClgDt: "2025-01-08",
      BankName: "",
      CardNo: "",
      AccountNo: "",
      IFSC: "",
      Status: "",
      Remark: "",
    });
    handleStepClick(0);

  };

  const handleEdit = async () => {
    setAllTextDisabled(false);
    setAllButtonDisabled(true);
    setDisableResidentFields(true);
  };

  const SendEmailHandler = () => {
    setIsConfirmDialogOpen(true);
  };

  const handleDelete = async () => {
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await fetchReceiptData(RecId, "D");
      if (response && response.data.Status === 0) {
        toast.success(response.data.Message || "Record deleted successfully.");
        setFormData({});
        setRecId(-1);
        handleStepClick(0);
      }
      // handleAdd();
      setOpenDeleteDialog(false);
      setAllTextDisabled(true);
      setAllButtonDisabled(false);
    } catch (error) {
      toast.error("An error occurred while deleting.");
    }
  };

  const handleCancelDelete = () => {
    setOpenDeleteDialog(false);
  };

  const handleNext = async () => {
    await fetchReceiptData(RecId, "N");
  };

  const handlePrevious = async () => {
    await fetchReceiptData(RecId, "P");
  };

  const handleCancel = async () => {
    // if (RecId && (typeof RecId === 'string' ? RecId.trim() !== "" : RecId !== -1)) {
    //   await fetchReceiptData(RecId, "L");
    // } else {
    //   console.log("Invalid RecId, skipping the backend request.");
    // }
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
    handleStepClick(0);
  };
  const handleExit = () => {
    navigate('/receipt-table')
  }

  const fetchPropertyDetails = async (bookId) => {
    try {
      const response = await GetReportTrnBooking({ BookId: bookId });
      const propertyId = response?.data?.Data?.TrnBookingList?.[0]?.PropId;
      if (propertyId) {
        setPropId(propertyId);
        return propertyId;
      }
      throw new Error('Property ID not found in response');
    } catch (error) {
      throw error;
    }
  };

  const generatePDFContent = () => {
    try {
      const doc = new jsPDF();
      const resident = residents?.find(r => r.ResidentId === formData.ResidentId);
      const residentName = resident?.Name || '';
      const residentMobile = resident?.Mobile || '';
      const residentEmail = resident?.Email || '';

      let yPos = 20;
      const pageWidth = doc.internal.pageSize.width;
      const margin = 20;
      const contentWidth = pageWidth - (2 * margin);
      doc.setTextColor(99, 91, 255);
      doc.setFontSize(25);
      doc.text(formData?.TrnRctVchrList && formData.TrnRctVchrList.filter(row => row.DBFLAG !== 'D')[0]?.PropName || 'No Property Name Available', pageWidth / 2, yPos, { align: 'center' });

      yPos += 10;
      doc.setFontSize(18);
      doc.setTextColor(0);
      doc.text('Receipt Voucher', pageWidth / 2, yPos, { align: 'center' });
      doc.autoTable({
        startY: yPos + 5,
        head: [
          [{ content: 'Receipt Summary', colSpan: 4, styles: { halign: 'left', fillColor: [99, 91, 255], textColor: 255, fontSize: 14, fontStyle: 'normal', cellPadding: 3, } }]
        ],
        body: [
          [
            { content: 'Receipt No', styles: { fontStyle: 'bold' } },
            formData.RecNo || '',
            { content: 'Receipt Date', styles: { fontStyle: 'bold' } },
            formData.RecDt ? moment(formData.RecDt).format('DD-MM-YYYY') : ''
          ],
          [
            { content: 'Resident Name', styles: { fontStyle: 'bold' } },
            residentName || '',
            { content: 'Resident Mobile', styles: { fontStyle: 'bold' } },
            residentMobile || ''
          ],
          [
            { content: 'Resident Email', styles: { fontStyle: 'bold' } },
            residentEmail || ''
          ]
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text('Transaction Details', margin, yPos);

      doc.autoTable({
        startY: yPos + 5,
        head: [
          [
            'TrjType', 'AdvNo', 'AdvDate', 'AdvAmt', 'RecdAmt', 'BalAmt', 'Remark'
          ]
        ],
        body: formData.TrnRctVchrList.filter(row => row.DBFLAG !== 'D').map(row => [
          row.RecFlag || '',
          row.PytAdvNo || '',
          formatValue(row.PytAdvDt),
          formatValue(row.PytAdvAmount),
          formatValue(row.Amount),
          formatValue(row.BalAmt),
          row.Remark || ''
        ]),
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(12);
      doc.setTextColor(0);
      doc.text('Thank you for choosing Clanbridge Living Pvt Ltd', margin, yPos);
      doc.text('For any queries, please contact: support@clanbridgeliving.in', margin, yPos + 5);
      return doc;
    } catch (error) {
      console.error('Error generating PDF:', error);
      return null;
    }
  };

  const formatValue = (value) => {
    if (typeof value === 'number') {
      return value.toFixed(2);
    }
    if (moment(value, moment.ISO_8601, true).isValid()) {
      return moment(value).format('DD-MM-YYYY');
    }
    return value || '';
  };

  const handleSendEmail = async () => {

    if (!formData?.ResidentId || !residents?.length) {
      toast.error("Resident information not available");
      return;
    }

    const resident = residents.find(r => r.ResidentId === formData.ResidentId);
    if (!resident?.Email) {
      toast.error("Resident email not available");
      return;
    }

    try {
      setLoading(true);

      const firstTransaction = formData?.TrnRctVchrList?.find(row => row.DBFLAG !== 'D');
      if (!firstTransaction?.BookId) {
        toast.error("Booking information not available");
        return;
      }

      const propertyId = await fetchPropertyDetails(firstTransaction.BookId);

      const userId = sessionStorage.getItem('UserId');

      const doc = generatePDFContent();
      if (!doc) {
        toast.error("Failed to generate PDF document");
        setLoading(false);
        return;
      }

      const pdfData = doc.output();
      const pdfBase64 = btoa(pdfData);
      const pdfDataUri = `data:application/pdf;base64,${pdfBase64}`;
      const RecNo = formData.RecNo;

      const emailPayload = {
        PropId: propertyId,
        UserId: userId,
        ToEmail: resident.Email ? [resident.Email] : [],
        Subject: `Payment Confirmation – Advice No:  ${formData.TrnRctVchrList[0].PytAdvNo}- Thank You`,
        ImgFolderNm: RecNo,
        Body: `Dear <strong>${resident.Name},</strong> <br><br>
        We are pleased to confirm receipt of your payment against the following details: <br><br>
        Payment Advice No. - <strong> [ ${formData.TrnRctVchrList[0].PytAdvNo} ]</strong> <br>
         Payment Date - <strong> ${moment(formData.RecDt).format('DD-MM-YYYY')}.</strong><br>
         Amount Received - <strong> ₹[ ${formData.TrnRctVchrList[0].Amount} ]</strong><br><br>
         Your account has been updated accordingly.
         <br><br>
         Thank you for making the payment on time and for being a valued resident of Clanbridge. We sincerely appreciate your continued trust in us and remain committed to ensuring your stay with us is comfortable and hassle-free.
          <br><br>
          If you have any questions regarding your payment or account, please feel free to contact us at sales@clanbridge.com or contact your resident captain.
        <br><br>
        Warm regards,<br>
        Team Clanbridge

         `,
        DocAttachments: [{
          FileName: `Receipt_${formData.RecNo}.pdf`,
          FileContent: pdfDataUri
        }],
        TblName: "TrnRctVchr",
        Id: RecId
      };

      const response = await SendEmailReceipt(emailPayload);
      if (response.data.Status === 0) {
        toast.success("Email sent successfully!");
        handleStepClick(0);
      } else {
        toast.error(response.data.Message || "Failed to send email");
      }
    } catch (error) {
      toast.error("Failed to send email. Please try again.");
    } finally {
      setLoading(false);
    }
    setIsConfirmDialogOpen(false);
  };

  const calculateTotalAmount = () => {
    const uniqueRows = [];
    const processedPytAdvNos = new Set();

    if (formData?.TrnRctVchrList && formData.TrnRctVchrList.length > 0) {
      formData.TrnRctVchrList.forEach(row => {
        if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== 'D') {
          uniqueRows.push(row);
          processedPytAdvNos.add(row.PytAdvNo);
        }
      });
    }

    if (tableData && tableData.length > 0) {
      tableData.forEach(row => {
        if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== 'D') {
          uniqueRows.push(row);
          processedPytAdvNos.add(row.PytAdvNo);
        }
      });
    }

    const totalAmount = uniqueRows.reduce((total, row) => {
      return total + parseFloat(row.Amount || 0);
    }, 0).toFixed(2);

    return totalAmount;
  };

    useEffect(() => {
    const totalAmount = calculateTotalAmount();
    const hasData = (formData?.TrnRctVchrList && formData.TrnRctVchrList.length > 0) || 
                    (tableData && tableData.length > 0);
    
    if (hasData && totalAmount > 0) {
      setFormData(prev => ({
        ...prev,
        AgstBill: totalAmount,
        // RcdAmt: !prev.RcdAmt || parseFloat(prev.RcdAmt) === parseFloat(prev.AgstBill || 0) ? 
        //         totalAmount : prev.RcdAmt
        RcdAmt: totalAmount
      }));
    }
  }, [tableData, formData.TrnRctVchrList]);

  const renderStepContent = (step) => {

    return (
      <Box sx={{ padding: "2px 16px" }}>
        {step === 0 ? (
          <ReceiptStepper1
            formData={formData}
            setFormData={setFormData}
            AllTextDisabled={AllTextDisabled}
            handleCancel={handleCancel}
            fetchReceiptData={fetchReceiptData}
            RecId={RecId}
            setAllButtonDisabled={setAllButtonDisabled}
            ResidentId={formData.ResidentId}
            handleStepClick={handleStepClick}
            setRecId={setRecId}
            onResidentsLoad={(residentsData) => setResidents(residentsData)}
            disableResidentFields={disableResidentFields}
            setDisableResidentFields={setDisableResidentFields}
            tableData={tableData}
            setTableData={setTableData}
            calculateTotalAmount={calculateTotalAmount}
          />
        ) : (
          <ReceiptStepper2
            formData1={formData}
            setFormData={setFormData}
            ResidentId={formData.ResidentId}
            AllButtonDisabledOuter={AllButtonDisabled}
            IsButtonSubmit={AllTextDisabled}
            handleCancel={handleCancel}
            fetchReceiptData={fetchReceiptData}
            RecId={RecId}
            setRecId={setRecId}
            handleStepClick={handleStepClick}
            emailSender={handleSendEmail}
            tableData={tableData}
            setTableData={setTableData}
          />
        )}
      </Box>
    );
  };

  const handleStepClick = (step) => {
    setActiveStep(step);
  };

  const buttonSx = {
    backgroundColor: '#635bff',
    borderRadius: '5px',
    padding: '5px',
    margin: { xs: '0px 5px', sm: '0px 5px' },
    "&:hover": {
      backgroundColor: "#1565c0",
      cursor: "pointer",
    },
    minWidth: { xs: '40px', sm: '40px', md: '60px' },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)",
      boxShadow: "none",
    }
  };
  return (
    <Grid>
      <Box className="form-container">
        <ToastContainer />
        <Dialog
          open={openDeleteDialog}
          onClose={handleCancelDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirmDelete}
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
            >
              Yes
            </Button>
            <Button
              onClick={handleCancelDelete}
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
        <Grid container spacing={2} className="rasidant_grid2" sx={{ padding: '10px' }}>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635BFF",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: { xs: "none", sm: "block" },
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={AllButtonDisabled}
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635BFF",
                  display: { xs: "none", sm: "block" },
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={AllButtonDisabled}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Receipt Voucher
            </Typography>


            <Tooltip title="Send Receipt Mail" arrow>
              <IconButton
                onClick={SendEmailHandler}
                disabled={AllButtonDisabled}
                sx={buttonSx}
              >
                <SendIcon sx={{ color: 'white' }} />
              </IconButton>
            </Tooltip>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Receipt Voucher"
                // mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                // onDelete={handleConfirmDelete}
                onDelete={handleDelete}
                onExit={handleExit}
                readOnlyMode={!AllButtonDisabled}
                onPrevious={handlePrevious}
                onNext={handleNext}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Stepper activeStep={activeStep} connector={<CustomStepConnector />} alternativeLabel>
              {steps.map((label, index) => (
                <Step
                  key={label}
                  onClick={() => {
                    if (!AllButtonDisabled) {
                      handleStepClick(index);
                    }
                  }}
                  disabled={AllButtonDisabled || (index !== activeStep && AllButtonDisabled)} // Disable step buttons based on the state
                  style={{ cursor: AllButtonDisabled ? "not-allowed" : "pointer" }}
                >
                  <CustomStepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon ownerState={{ ...props, active: activeStep === index }}>
                        {index + 1}
                      </CustomStepIcon>
                    )}
                  >
                    {label}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>

          </Grid>

          <Grid item xs={12}>
            {renderStepContent(activeStep)}
          </Grid>
        </Grid>
      </Box>
      <div style={{ display: 'none' }}>
        {residents && residents.length > 0 && formData.ResidentId && formData.TrnRctVchrList && formData.TrnRctVchrList.length > 0 ? (
          <ReceiptPrint
            contentRef={contentRef}
            formData={formData}
            residents={residents}
            pytAdvId={
              formData.TrnRctVchrList
                .filter(row => row.DBFLAG !== 'D')
                .map(row => row.PytAdvId)
                .filter(id => id && id !== 0)
                .join(',') || '1'
            }
          />
        ) : null}
      </div>

      <ConfirmDialog
        open={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        title="Send Email"
        content="Are you sure you want to send Email ?"
        onConfirm={handleSendEmail}
      />
    </Grid>
  );
};

export default StepperForm;